<template>
    <div class="panel">
        <COPDTable v-bind:tableData="vitals" />
        <!-- <div class="copd-table">
            <div class="copd-tbl-header">
                <div class="copd-tbl-col">My Vitals</div>
                <div class="copd-tbl-col">Last</div>
                <div class="copd-tbl-col">Today</div>
            </div>
            <div class="copd-tbl-row row-a">
                <div class="copd-tbl-col">Temperature</div>
                <div class="copd-tbl-col">37.0C</div>
                <div class="copd-tbl-col"><span v-if="newVitals.temperature">{{ newVitals.temperature }}C</span></div>
            </div>
            <div class="copd-tbl-row row-b">
                <div class="copd-tbl-col">Blood Pressure</div>
                <div class="copd-tbl-col">120 / 80</div>
                <div class="copd-tbl-col"><span v-if="newVitals.systolic && newVitals.diastolic">{{ newVitals.systolic }} / {{ newVitals.diastolic }}</span></div>
            </div>
            <div class="copd-tbl-row row-c">
                <div class="copd-tbl-col">Blood Oxygen</div>
                <div class="copd-tbl-col">90%</div>
                <div class="copd-tbl-col"><span v-if="newVitals.bloodOxygen">{{ newVitals.bloodOxygen }}%</span></div>
            </div>
            <div class="copd-tbl-row row-d">
                <div class="copd-tbl-col">Pulse</div>
                <div class="copd-tbl-col">65</div>
                <div class="copd-tbl-col"><span v-if="newVitals.pulse">{{ newVitals.pulse }}</span></div>
            </div>
        </div> -->
    </div>
</template>

<script>
    import COPDTable from '@/components/COPDTable.vue'

    export default {
        name: 'Vitals_panel',
        created: function() {
            vidbaby.$(document).on('na-extractedEntity.vidbaby', (event, data) => {
                //Assume celsius if nothing
                for(var i in data) {
                    if(typeof this.newVitals[i] !== 'undefined') {
                        if(data[i]) {
                            if(data[i][0]) data[i] = data[i][0];
                            if(data[i].numberValue) this.newVitals[i] = data[i].numberValue;
                            else if(data[i].stringValue) this.newVitals[i] = data[i].stringValue;
                        }
                    }
                }
            });
            vidbaby.$(document).on('na-response.vidbaby', (event, data) => {
                if(typeof this.showVitals[data.customView] !== 'undefined') {
                    this.showVitals[data.customView] = true;
                }
            });
        },
        computed: {
            vitals: function() {
                return {
                    headers: [ 'My Vitals', 'Last', 'Today'],
                    items: [
                        {
                            id: 'GetTemp',
                            show: this.showVitals.GetTemp,
                            class: 'row-a',
                            cols: ['Temperature', '37.0°C', this.newVitals.temperature ? this.newVitals.temperature + ((this.newVitals.temperature > 50) ? '°F' : '°C') : '']
                        },{
                            id: 'GetPressure',
                            show:  this.showVitals.GetPressure,
                            class: 'row-b',
                            cols: ['Blood Pressure', '120 / 80', (this.newVitals.systolic && this.newVitals.diastolic) ? this.newVitals.systolic + ' / ' + this.newVitals.diastolic : null]
                        },{
                            id: 'GetOxygen',
                            show:  this.showVitals.GetOxygen,
                            class: 'row-c',
                            cols: ['Blood Oxygen', '90%', this.newVitals.bloodOxygen ? this.newVitals.bloodOxygen + '%' : '']
                        },{
                            id: 'GetPulse',
                            show:  this.showVitals.GetPulse,
                            class: 'row-d',
                            cols: ['Pulse', '65', this.newVitals.pulse]
                        }
                    ]
                };
            }
        },
        data: function() {
            return {
                showVitals: {
                    GetTemp: true,
                    GetPressure: false,
                    GetOxygen: false,
                    GetPulse: false
                },
                newVitals: {
                    temperature: null,
                    systolic: null,
                    diastolic: null,
                    bloodOxygen: null,
                    pulse: null
                }
            };
        },
        components: {
            COPDTable
        }
    }
</script>

<style lang="stylus">
    .copd-tbl-col
        flex: 1
        &:first-child
            flex: 2
</style>